import * as Enum from './BcEnums';
export class CBcHospitalHisConfigDatabase {
    constructor(op) {
        this.name = 'database';
        this.type = Enum.EBcHospitalHisConfigDatabaseType.None;
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
export class CBcHospitalHisConfigWebService {
    constructor(op) {
        this.name = 'webservice';
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
export class CBcHospitalHisConfigObject {
    constructor(type, op) {
        const that = this;
        that.type = type;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                if (k !== 'info')
                    that[k] = op[k];
            });
        }
        that.info = /web/i.test(that.type) ? new CBcHospitalHisConfigWebService(op && op.info) : new CBcHospitalHisConfigDatabase(op && op.info);
    }
}
export class CBcHospitalHisInfo {
    constructor(op) {
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                if (k !== 'config')
                    that[k] = op[k];
            });
        }
        that.config = new CBcHospitalHisConfigObject(that.type, op && op.config);
    }
}
export class CBcPrivilegeOperationInfo {
    constructor(op) {
        this.objectName = 'operationInfo';
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
export class CBcPrivilegeElementInfo {
    constructor(op) {
        this.objectName = 'elementInfo';
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
    setParams(v) {
        if (v instanceof Object)
            this.params = v;
        else
            try {
                this.params = JSON.parse(v);
            }
            catch (e) {
                this.params = {};
            }
    }
}
export class CBcPrivilegeMenuInfo {
    constructor(op) {
        this.objectName = 'menInfo';
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
export class CBcPrivilegeFileInfo {
    constructor(op) {
        this.objectName = 'fileInfo';
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
export class CBcPrivilegeInfo {
    constructor(info, op) {
        const that = this;
        if (!(info instanceof CBcPrivilegeOperationInfo) && !(info instanceof CBcPrivilegeElementInfo) && !(info instanceof CBcPrivilegeMenuInfo) && !(info instanceof CBcPrivilegeFileInfo)) {
            op = info;
        }
        else
            this.info = info;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
export class CBcPrivilegeTree extends CBcPrivilegeInfo {
    constructor(op) {
        super();
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                if (k === 'children') {
                    const chils = op[k];
                    if (chils.length && !that.children)
                        that.children = [];
                    const groups = {};
                    // 查找出分组条目
                    chils.forEach((it, i) => {
                        groups[it.group] = (groups[it.group] || []).concat([it]);
                    });
                    // 按分组存放在子条目中
                    for (var k in groups)
                        that.children.push({ id: k, name: k, children: groups[k].map((pri) => new CBcPrivilegeTree(pri)) });
                }
                else
                    that[k] = op[k];
            });
        }
    }
}
export class CBcPrivilegeGroup {
    constructor(info, op) {
        this.funs = [];
        this.datas = [];
        const that = this;
        if (!(info instanceof Array))
            op = info;
        else {
            for (const it of info) {
                if (/operation|file/i.test(it.type))
                    this.datas.push(new CBcPrivilegeInfo(it));
                else if (/element|menu/i.test(it.type))
                    this.funs.push(new CBcPrivilegeInfo(it));
            }
        }
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
export class CBcRoleInfo {
    constructor(op) {
        this.privileges = [];
        this.privilegeGroup = new CBcPrivilegeGroup();
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
export class BcUtils {
    static random(len = 6) {
        len = len || 32;
        const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /* 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1 */
        const maxPos = chars.length;
        let pwd = '';
        for (let i = 0; i < len; i++) {
            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }
}
export class CBcHospitalHandlerInfo {
    constructor(op) {
        const that = this;
        if (op && /object/i.test(typeof op)) {
        }
    }
}
